import React from "react";
import { Link } from "react-router-dom";
import Site2Layout from "./Site2Layout";
import worldMap from "../../Assets/HomePageGlobal.png";

const STATS = [
  { value: "15+", label: "Years of Leadership Experience" },
  { value: "50+", label: "Projects Delivered" },
  { value: "12+", label: "Countries Reached" },
  { value: "100%", label: "Client Commitment" },
];

const HIGHLIGHTS = [
  { icon: "📊", title: "Market Research", desc: "Identify latent and emerging opportunities before your competition." },
  { icon: "🌍", title: "Global Market Entry", desc: "Seamless expansion into India or international markets." },
  { icon: "🏭", title: "Project Management", desc: "End-to-end execution from concept to commissioning." },
  { icon: "🤝", title: "B2B Consulting", desc: "Strategic advisory for sustainable business development." },
];

const Site2Home = () => (
  <Site2Layout
    tag="Welcome"
    title="Where Global Strategy Meets Local Expertise"
    subtitle="Tarak Global Enterprises — your trusted partner for market research, business growth, and market entry since 2020."
  >
    {/* Hero Map Section */}
    <section 
      style={{ 
        position: "relative",
        backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.95) 40%, rgba(255, 255, 255, 0.7) 100%), url(${worldMap})`,
        backgroundSize: "cover",
        backgroundPosition: "center right",
        backgroundRepeat: "no-repeat"
      }} 
      className="py-24 px-6 border-b border-gray-100"
    >
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center min-h-[400px]">
        <div className="flex flex-col justify-center text-left">
          <span style={{ color: "#481F57" }} className="text-xs font-bold tracking-widest uppercase mb-3 block">
            Global Strategy & Marketing
          </span>
          <h2 className="text-3xl lg:text-5xl font-extrabold text-[#481F57] leading-tight mb-5">
            Navigating Opportunities <span className="text-purple-600">in Emerging Markets</span>
          </h2>
          <p className="text-gray-700 text-base sm:text-lg leading-8 mb-8">
            At Tarak Global Enterprises, we believe it is essential to identify what opportunities are available in the market that can be seized to achieve growth objectives, before entering new markets or penetrating existing ones.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/services"
              style={{ background: "linear-gradient(135deg,#481F57,#6B3080)" }}
              className="text-white font-bold text-base px-8 py-4 rounded-full text-center shadow-md hover:opacity-90 transition-opacity"
            >
              Explore Services
            </Link>
            <Link
              to="/contact"
              className="text-gray-800 font-bold text-base px-8 py-4 rounded-full text-center border border-gray-300 hover:border-gray-500 hover:bg-gray-50 transition-all"
            >
              Get in Touch
            </Link>
          </div>
        </div>
        
        {/* Empty right column so the world map remains beautifully visible on the right */}
        <div className="hidden lg:block"></div>
      </div>
    </section>

    {/* Stats */}
    <section
      style={{ borderTop: "1px solid rgba(72, 31, 87, 0.08)", borderBottom: "1px solid rgba(72, 31, 87, 0.08)", backgroundColor: "#f9fafb" }}
      className="py-14 px-6"
    >
      <div className="max-w-5xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
        {STATS.map((s, i) => (
          <div key={i}>
            <p
              style={{ background: "linear-gradient(90deg,#481F57,#A855F7)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}
              className="text-4xl font-extrabold mb-1"
            >
              {s.value}
            </p>
            <p className="text-gray-500 text-sm font-semibold">{s.label}</p>
          </div>
        ))}
      </div>
    </section>

    {/* About Detailed */}
    <section style={{ backgroundColor: "#ffffff" }} className="py-20 px-6">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
        <div className="text-left">
          <span style={{ color: "#481F57" }} className="text-xs font-bold tracking-widest uppercase mb-3 block">
            About Tarak Global
          </span>
          <h2 className="text-3xl lg:text-4xl font-extrabold text-[#481F57] leading-tight mb-5">
            Identifying Opportunity <span className="text-purple-600">Before the Market Does</span>
          </h2>
          <div className="h-[2px] bg-purple-200 w-16 mb-6"></div>
          <p className="text-gray-700 text-base leading-8 mb-4">
            Established in 2020 as a consultancy and project management firm, Tarak Global Enterprises undertakes projects for market research, market intelligence studies, marketing, business growth, feasibility studies, and setting up new factories or divisions.
          </p>
          <p className="text-gray-700 text-base leading-8 mb-8">
            We conduct market opportunity assessment studies to identify and quantify latent, existing and emerging growth opportunities that help marketers in allocating resources in the right direction, and in devising sound marketing strategies.
          </p>
          <Link
            to="/contact"
            style={{ color: "#481F57", borderColor: "#481F57" }}
            className="inline-flex items-center gap-2 font-bold border-2 rounded-full px-6 py-2 hover:bg-[#481F57]/5 transition-colors"
          >
            Partner with us →
          </Link>
        </div>

        {/* Info card */}
        <div
          style={{ background: "#f9fafb", border: "1px solid rgba(72, 31, 87, 0.12)" }}
          className="rounded-2xl p-8 text-left shadow-sm"
        >
          {[
            { label: "Headquarters", value: "Vasai Road East, Maharashtra, India" },
            { label: "Founded", value: "2020" },
            { label: "Focus", value: "B2B Consulting & Market Entry" },
            { label: "Reach", value: "India ↔ Global Markets" },
            { label: "Email", value: "tarakglobal@gmail.com" },
          ].map((item, i) => (
            <div
              key={i}
              className="flex flex-col sm:flex-row gap-1 sm:gap-4 py-4 border-b border-gray-200 last:border-0"
            >
              <span style={{ color: "#481F57", minWidth: "130px" }} className="text-xs font-bold tracking-widest uppercase">
                {item.label}
              </span>
              <span className="text-gray-700 text-sm font-semibold">{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Highlights */}
    <section style={{ backgroundColor: "#f9fafb", borderTop: "1px solid rgba(72, 31, 87, 0.08)" }} className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl lg:text-4xl font-extrabold text-[#481F57] text-center mb-12">
          What We <span className="text-purple-600">Bring to the Table</span>
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {HIGHLIGHTS.map((h, i) => (
            <div
              key={i}
              style={{ background: "#ffffff", border: "1px solid rgba(72, 31, 87, 0.1)" }}
              className="rounded-2xl p-6 hover:shadow-md transition-all text-left"
            >
              <div
                style={{ background: "linear-gradient(135deg,#481F57,#6B3080)" }}
                className="w-12 h-12 rounded-xl flex items-center justify-center text-2xl mb-4"
              >
                {h.icon}
              </div>
              <h3 className="text-gray-900 font-bold text-base mb-2">{h.title}</h3>
              <p className="text-gray-600 text-sm leading-7">{h.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  </Site2Layout>
);

export default Site2Home;
